import styled from "styled-components";

export const SocialMediaLinks = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
`;

export const SocialLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const SocialIcon = styled.span`
  background-image: url("//imgak.mmtcdn.com/pwa_v3/pwa_commons_assets/desktop/landingSprite2@3x.png");
  background-repeat: no-repeat;
  display: inline-block;
  background-size: 200px 700px;
  font-size: 0;

  &.instagramIcon {
    width: 47px;
    height: 46px;
    background-position: -63px -50px;
  }

  &.twiiterIcon {
    width: 36px;
    height: 37px;
    background-position: -120px -52px;
  }

  &.linkedinIcon {
    width: 44px;
    height: 45px;
    background-position: -8px -51px;
  }

  &.facebookIcon {
    width: 20px;
    height: 42px;
    background-position: -166px -48px;
  }
`;
